<template>
  <app-interaction-preview-ads-gpt v-if="dataInteraction.tipo === 'GOOGLE_PUBLISHER_TAG'"  :data-interaction="dataInteraction" @next="(optionId) => $emit('next', optionId)"></app-interaction-preview-ads-gpt>
  <app-interaction-preview-ads-vast v-else-if="dataInteraction.tipo === 'VAST'"  :data-interaction="dataInteraction" @next="(optionId) => $emit('next', optionId)"></app-interaction-preview-ads-vast>
</template>

<script>
import AppInteractionPreviewAdsGpt from "./gpt/InteractionPreviewAdsGpt.vue";
import AppInteractionPreviewAdsVast from "./vast/InteractionPreviewAdsVast.vue";


export default {
  components: {
    AppInteractionPreviewAdsGpt,
    AppInteractionPreviewAdsVast
  }, 

  props: {
    dataInteraction: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
